export const TRIAL_PAGES_GO_TO_THE_TRIAL = 'go_to_the_trial';
